
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/retirement-planning-hero.webp';
import highResMobileImageWebp from './images/retirement-planning-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='retirement-planning-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Retirement Planning'
      headingText={
        <>
          It&#39;s never too late for a <WidowBlock>retirement plan.</WidowBlock>
        </>
      }
      descriptionText={
        <>
          No matter what you see yourself doing or the places you picture yourself exploring when 9&#8211;5 is all yours, we can help you plan for it.
        </>
      }
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Start planning',
        ariaLabel: 'Start planning with a financial professional',
        children: '',
      }}
      backgroundImageAriaLabel='A grandmother laughing while holding her granddaughter in the woods'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
    />
  );};
